const PRO_X = 'PRO_X'
const PRO_X2 = 'PRO_X2'
const NEXT_GEN = 'NEXT_GEN'

const objects = {
    [PRO_X]: {
        type: PRO_X,
        label: 'Pro X', // TODO: verify label, serial # format
        image: '/images/pro-device-icon.png',
        serialNumberPlaceholder: 'ABCdefg123456789',
        serialNumberRegex: '^[A-Za-z0-9]{5,32}$',
        serialNumberMinLength: 5,
        serialNumberMaxLength: 32,
        serialNumberHelperText: 'Serial Number format for X is TBD',
    },
    [PRO_X2]: {
        type: PRO_X2,
        label: 'Pro X2', // TODO: verify label, serial # format
        image: '/images/pro-device-icon.png',
        serialNumberPlaceholder: 'MXP123456789',
        serialNumberRegex: '^(?:PNE|MXR|MXP|MNE)\\d{9}$',
        serialNumberMinLength: 12,
        serialNumberMaxLength: 12,
        serialNumberHelperText: 'Serial Number format is PNE, MXR, MNE, or MXP followed by 9 digits',
    },
    [NEXT_GEN]: {
        type: NEXT_GEN,
        label: 'Next Gen',
        image: '/images/pro-device-icon.png',
        serialNumberPlaceholder: 'NGS-E2624-00001',
        serialNumberRegex: '^NGS-E\\d{2}(?:0[1-9]|[1-4]\\d|5[0-3])-\\d{5}$',
        serialNumberMinLength: 5,
        serialNumberMaxLength: 32,
        serialNumberHelperText:
            'Serial Number format for Next Gen is NGS ' +
            'followed by E, 2 digit year, 2 digit week, and finally 5 digits.',
    },
}

export default Object.freeze(objects)

export const byValue = (value) => {
    return objects[value.toUpperCase()]
}
